module.exports = __webpack_public_path__ + "img/circle_num_1_green.cf69a6f7.svg";